import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CmsFacilityResolver } from '@digital-platform/rs-cms/services';
import { FacilitiesComponent } from './facilities/facilities.component';
import { FacilityComponent } from './facility/facility.component';

const routes: Routes = [
  {
    path: '',
    // will redirect to ES FF until /facilities is built out for resi and biz
    redirectTo: 'environmental-solutions',
    pathMatch: 'full',
  },
  {
    path: ':state/:name',
    component: FacilityComponent,
    resolve: {
      facility: CmsFacilityResolver,
    },
  },
  {
    path: 'environmental-solutions',
    component: FacilitiesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RsFrontendFeatureFacilitiesRoutingModule {}
